// extracted by mini-css-extract-plugin
module.exports = {"Page":"ManagerCoin_Page__3Di9d"};